import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-section">
      <div className="footer-section-container">
      </div>
    </footer>
  );
}

export default Footer;
